module.exports = __webpack_public_path__ + "static/media/Down_Arrow.583bf6af.svg";